import { SimpleImage } from 'components/simple-image';
import { Column, Container, Row } from 'components/ui-kit/grid';
import BraceleMocap from 'public/images/collaborations/utkonos/bracelete_mocap.jpg';
import LongslivMocap from 'public/images/collaborations/utkonos/long_mocap.jpg';
import StickersMocap from 'public/images/collaborations/utkonos/sticker_mpcap.jpg';
import { type JSX } from 'react';
import styles from '../collaboration-utkonos-page.module.scss';

export const HeroBlock = (): JSX.Element => {
  return (
    <Container>
      <Row>
        <Column span={{ s: 12, m: 4, l: 5 }}>
          <SimpleImage src={LongslivMocap} alt="" className="ratio-9-16" />
        </Column>
        <Column span={{ s: 12, m: 8, l: 7 }} className={styles.relative}>
          <h1 className={styles.heroText}>
            <span className={styles.heroTextFirstLine}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;День
              <SimpleImage
                src={StickersMocap}
                alt=""
                width={155}
                layout="fixed"
                className={styles.heroStickers}
              />
            </span>
            <span>предпри-</span>
            <div className={styles.heroTextLastLine}>
              <SimpleImage
                src={BraceleMocap}
                alt=""
                width={185}
                layout="fixed"
                className={styles.heroBracelete}
              />
              <div className={styles.heroTextLastLineText}>
                <div>нимателя</div>
                <div className={styles.heroTextLastLineSubscription}>
                  Или утконоса?
                </div>
              </div>
            </div>
          </h1>
          <div className={styles.heroSubText}>
            Не&nbsp;видите связи? А&nbsp;она есть&nbsp;&mdash; пройдите тест
            и&nbsp;убедитесь, что мы&nbsp;не&nbsp;сошли с&nbsp;ума!
          </div>
        </Column>
      </Row>
    </Container>
  );
};
